/**
 * Workspace utilities for parsing and managing workspace context
 */

/**
 * Parse workspace slug from current URL
 * Expected format: host/w/my-workspace/...
 * Returns the workspace slug or null if not found
 */
export function parseWorkspaceSlugFromUrl(): string | null {
  const pathname = window.location.pathname;

  // Remove leading slash and split by '/'
  const pathParts = pathname.replace(/^\//, '').split('/');

  // Check if path starts with 'w' and has a slug
  if (pathParts.length >= 2 && pathParts[0] === 'w' && pathParts[1]) {
    return pathParts[1];
  }

  return null;
}

/**
 * Get current workspace slug with fallback
 * Returns the workspace slug or throws error if not found
 */
export function getCurrentWorkspaceSlug(): string {
  const slug = parseWorkspaceSlugFromUrl();

  if (!slug) {
    throw new Error(
      'Workspace slug not found in URL. Expected format: /w/my-workspace/...'
    );
  }

  return slug;
}
